import React from 'react';
import { MaterialMeanResponse } from '@/api/bol';
import { DeleteConfirmDialog } from '@/components/common/DeleteConfirmDialog';

export interface MaterialMeanDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  materialMean: MaterialMeanResponse | null;
}

export const MaterialMeanDeleteDialog: React.FC<MaterialMeanDeleteDialogProps> = ({
  open,
  onClose,
  onConfirm,
  materialMean,
}) => {
  return (
    <DeleteConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      itemType="material-mean"
      itemId={materialMean?.id || ''}
    />
  );
};
